import { styled } from '@linaria/react';

import { COLORS_MAP, type CommonProps } from '../constants';

export const SIZES = [undefined, 'L', 'M', 'S', 'XS'] as const;
export type TSize = (typeof SIZES)[number];

const FONT_SIZES = {
	XS: '1.2rem',
	S: '1.4rem',
	M: '1.6rem',
	L: '1.8rem',
};

const LINE_HEIGHTS = {
	XS: '2.0rem',
	S: '2.2rem',
	M: '2.2rem',
	L: '2.6rem',
};

export const Headline = styled.p<CommonProps<TSize>>`
	color: ${({ color }) => (color ? COLORS_MAP[color] : 'inherit')};
	font-size: ${({ size = 'M' }) => FONT_SIZES[size]};
	font-weight: var(--font-weight-bold);
	line-height: ${({ size = 'M' }) => LINE_HEIGHTS[size]};

	text-align: ${({ align }) => align ?? 'center'};
	text-transform: ${({ transform }) => transform ?? 'inherit'};
	text-wrap: balance;
	white-space: ${({ multiline }) => (multiline ? 'pre-wrap' : 'inherit')};
	word-break: ${({ multiline }) => (multiline ? 'break-word' : 'inherit')};
	&::first-letter {
		text-transform: ${({ capitalizeFirstLetter }) =>
			capitalizeFirstLetter ? 'uppercase' : 'inherit'};
	}
`;
